module.exports = __webpack_public_path__ + "static/media/icon_android.207b3493.png";